import React, { ReactElement } from 'react'
import { VoteData } from '@/database/vote'
import { formatDateString } from '@/utils/formatting'
import Box from '@/components/boxes/Box'
import LoadImageOnDemand from '@/components/LoadImageOnDemand'

interface VotedProps {
    voteData: VoteData
}

const VotedArtWork = ({ voteData }: VotedProps): ReactElement => {
    try {
        return (
            <div key={voteData.vote.id} className="artwork-box">
                <div className="menu-wrapper-row">
                    <div>
                        <div className={'header-container'}>
                            <Box caption={'Vote'} text={'#' + voteData.vote.id} />
                            {voteData.art.nft?.tokenId && voteData.art.nft.tokenId > -1 && (
                                <div>
                                    <Box caption={'NFT'} text={'#' + voteData.art.nft.tokenId} />
                                </div>
                            )}
                            {!voteData.art.nft?.tokenId && (
                                <div>
                                    <Box caption={'ART'} text={'#' + voteData.art.id} />
                                </div>
                            )}
                            <div>
                                <Box caption={'Amount'} text={voteData.vote.amount} />
                            </div>
                        </div>
                        <div className={'padding-bottom-five'}>
                            <Box
                                caption={'Vote Time'}
                                text={formatDateString(voteData.vote.createdAt)}
                                styleText={'small'}
                            />
                        </div>
                    </div>
                    <div className="image-container width-thirty width-max-100">
                        <LoadImageOnDemand
                            id={'art' + voteData.art.id}
                            alt={voteData.art.prompt}
                            imageId={voteData.art.image.id}
                            style="z-index-zero"
                            link={
                                voteData.art.nft?.tokenId
                                    ? '/crazy#nft-' + voteData.art.nft.tokenId + '/'
                                    : '/crazy#art-' + voteData.art.id + '#mint/'
                            }
                        />
                    </div>
                </div>
            </div>
        )
    } catch (error) {
        // Handle the error here or display a fallback image
        console.error('Error rendering image:', error)
        return <div />
    }
}

export default VotedArtWork
